"use client";

import { c as _c } from "react/compiler-runtime";
import { groupBySection } from "@/lib/setup-checklist-sections";
import type { SetupChecklistResponse } from "@/types/setup-checklist";
import { SegmentedBar } from "./segmented-bar";
export function SetupChecklistHeader(t0) {
  const $ = _c(23);
  const {
    data,
    children,
    trailing
  } = t0;
  let done;
  let sections;
  let t1;
  if ($[0] !== data.items) {
    sections = groupBySection(data.items);
    done = sections.filter(_temp).length;
    t1 = sections.filter(_temp2);
    $[0] = data.items;
    $[1] = done;
    $[2] = sections;
    $[3] = t1;
  } else {
    done = $[1];
    sections = $[2];
    t1 = $[3];
  }
  const critical = t1.length;
  const t2 = `${done} of ${sections.length} sections done, ${critical} with critical items open`;
  let t3;
  if ($[4] !== critical || $[5] !== done || $[6] !== sections.length || $[7] !== t2) {
    t3 = <SegmentedBar filled={done} highlighted={critical} total={sections.length} label={t2} />;
    $[4] = critical;
    $[5] = done;
    $[6] = sections.length;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = ` / ${sections.length}`;
  let t5;
  if ($[9] !== t4) {
    t5 = <span className="text-foreground-muted">{t4}</span>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== done || $[12] !== t5) {
    t6 = <span className="text-caption-strong tabular-nums text-foreground">{done}{t5}</span>;
    $[11] = done;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6 || $[15] !== trailing) {
    t7 = <div className="flex items-center gap-1">{t6}{trailing}</div>;
    $[14] = t6;
    $[15] = trailing;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== children || $[18] !== t7) {
    t8 = <div className="flex items-center justify-between gap-3">{children}{t7}</div>;
    $[17] = children;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t3 || $[21] !== t8) {
    t9 = <div className="space-y-2.5">{t3}{t8}</div>;
    $[20] = t3;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}
function _temp2(section_0) {
  return section_0.criticalOpenCount > 0;
}
function _temp(section) {
  return section.isComplete;
}